import React, { useState } from "react";
import styled from "styled-components";
import { Button, Text, Alert, Modal } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SlackVerificationCodeForm from "~/forms/SlackVerificationCodeForm";
import slackVerificationCodeSchema from "~/forms/SlackVerificationCodeForm/slackVerificationCodeSchema";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const SlackVerificationModal = _ref => {
  let {
    verifyUser,
    onClose,
    onSuccess
  } = _ref;
  const {
    t
  } = useTranslation();
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control
  } = useForm({
    resolver: yupResolver(slackVerificationCodeSchema),
    defaultValues: {
      code: ""
    }
  });
  const onSubmit = handleSubmit(_ref2 => {
    let {
      code
    } = _ref2;
    if (verifyUser) {
      setLoading(true);
      api.verifySlackUserCode(verifyUser, code).then(() => {
        onSuccess(verifyUser);
      }).catch(e => {
        setError(handleError(e));
      }).finally(() => {
        setLoading(false);
      });
    }
  });
  const handleClose = () => {
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("SlackVerificationModal.verifySlack"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "420px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    s: {
      mb: 3
    }
  }, t("SlackVerificationModal.description")), /*#__PURE__*/React.createElement(SlackVerificationCodeForm, {
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: loading,
    fullWidth: true,
    rounded: true
  }, t("SlackVerificationModal.sendCode")))));
};
export default SlackVerificationModal;